var codeJson = {
  
    "CGP073":{
        "Blue":"#19298C",
        "Yellow":"#E95D98",
        "Pink":"#E95D98",
    },
  	"CGP014":{
        "Blue":"#19298C",
        "Yellow":"#E95D98",
        "Pink":"#E95D98",
    }, 
    "CGP072":{
        "default":"#A286BD"
   }, 
  "CGP086":{
        "default":"#D93A2A"
  }, 
    "CGP087":{
        "default":"#D93A2A"
   }, 
 
    "CGP088":{
        "default":"#D93A2A"
   }, 
  "CGP089":{
        "default":"#1A9F44"
   }, 
  "CGP090":{
        "default":"#1A9F44"
   } 
}